import { track } from '../components/crossSell/analytics/analyticsAdapterClient';
import { createClient, createMessageBusHandler, getFeatureVariant } from '@sb/feature-flags';
import DeviceDetector from '../components/DeviceDetector';

const NGS_PLATFORMS = {
    Desktop: 'desktop',
    Tablet: 'tablet',
    MobileWeb: 'mobile',
    NativeIos: 'native_ios',
    NativeAndroid: 'native_android',
};

const getPlatformLikeInNGS = () => {
    if (DeviceDetector.isNativeAndroid()) {
        return NGS_PLATFORMS.NativeAndroid;
    } else if (DeviceDetector.isNativeiOS()) {
        return NGS_PLATFORMS.NativeIos;
    } else if (DeviceDetector.isMobile()) {
        return NGS_PLATFORMS.MobileWeb;
    } else if (DeviceDetector.isTablet()) {
        return NGS_PLATFORMS.Tablet;
    } else if (DeviceDetector.isDesktop()) {
        return NGS_PLATFORMS.Desktop;
    }
};

const trackAnalytics = (EventAction, EventLabel) => {
    const payload = {
        event: 'optimizely_fs',
        payload: {
            EventAction,
            EventLabel,
        },
    };

    track(payload);
};

const onFeatureRequest = ({ featureKey, isEnabled, variables }) => {
    const { version } = variables || {};
    const variant = getFeatureVariant(isEnabled, version);
    trackAnalytics(featureKey, variant);
};

const onExperimentRequest = (feature) => {
    const { experimentKey, variant } = feature;
    trackAnalytics(experimentKey, variant);
};

const init = () => {
    const featureFlagsClient = createClient(getPlatformLikeInNGS(), {
        onFeatureRequest,
        onExperimentRequest,
        sdkKey: window.whStatic.config.optimizely.sdkKey,
    });
    const messageBusFeatureFlagsClient = createMessageBusHandler(featureFlagsClient);
    messageBusFeatureFlagsClient.start();
};

export default {
    init,
};
